﻿import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomBadge from "@/components/desktop/badge/CustomBadge";

import classes from "../maintainers.module.scss";
import { dateToLocale } from "@/services/Utils";

import { ReactComponent as ShowSvg } from "@/assets/images/desktop/show2.svg";
import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";

const IncidentsTableBody = ({ handleDelete }) => {
	const navigate = useNavigate();

	const { incidents } = useSelector((state) => state.maintainers_incidents);

	return (
		<tbody>
			{incidents &&
				incidents.map((item, i) => {
					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>
							<td className={`${classes.table_td} `}>
								<div className={`${classes.table_div}`}>{item.incidents_title}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>{dateToLocale(item.creation_date)}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									<CustomBadge
										variant={item.status_name === "Solucionado" ? "success" : item.status_name === "En Proceso" ? "warning" : "danger"}
									>
										{item.status_name}
									</CustomBadge>
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									<ShowSvg className={classes.icon} onClick={() => navigate("/mantenedores/incidencias/ver/" + item.id)} />
									<PencilSvg className={classes.icon} onClick={() => navigate("/mantenedores/incidencias/editar/" + item.id)} />
									<RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default IncidentsTableBody;
